// Hand the reader a file the console already holds — an audit export's CSV — as a download.

/** How long the file's object URL outlives the click that saves it. */
const RELEASE_AFTER_MS = 60_000;

export function saveFile(name: string, contents: string, type: string): void {
  const url = URL.createObjectURL(new Blob([contents], { type }));
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  link.hidden = true;
  document.body.append(link);
  link.click();
  link.remove();
  // Not at once: a browser may still be reading the URL when `click()` returns.
  setTimeout(() => URL.revokeObjectURL(url), RELEASE_AFTER_MS);
}
